import {ApplicationRef, Component, OnInit, ViewChild} from '@angular/core';
import {AlertController, IonicPage, NavController, NavParams} from 'ionic-angular';
import {OauthService} from '../../shared/services/oauth.service';
import {LoginService} from './services/login.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LocalStorageService} from '../../shared/services/localStorage.service';
import {ToastDirective} from '../../shared/directives/toast/toast';
import {User} from '../../shared/models/user/user.model';
import {CorePage} from '../../shared/interfaces/corePage.interface';
import {AuthService} from '../../shared/services/auth.service';
import {ContextInitializerService, UserStorageService} from '../../shared/services';
import {LoadingService} from '../../shared/services/loading.service';
import {EnvironnementInitializer} from '../../core/app/environnement-initializer.service';
import {EnvironnementProvider} from '../../core/app/environnement-provider.service';
import {AppProvider} from '../../core/app/app-provider.service';
import {WebSliderService} from "../../shared/services/webSlider.service";
import { MenuService } from '../../shared/services/menu.service';
import {EnvironnementRequiredService} from "../../core/app/environnement-required.service";
import {Config} from "../../shared/services/config.service";

declare var hcaptcha: any;
/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  name: 'login-page'
})
@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage implements CorePage, OnInit {
  public isLoggedIn = false;
  public loginForm: FormGroup;
  public user: User = new User({} as User);
  public allowedMode = ['elu', 'salarie'];
  public authService;
  public currentMode;
  private _version: string;
  public username: string = null;
  public connexionLoginTemp: boolean = false;
  public webSliderConnexion;
  public showPassword = false;

  public loading = false;
  public modal2FA = null;
  public errorOtp;
  public otp: Array<string> = [null, null, null, null, null, null];
  public submitted = false;
  public captchaToken;
  public hCaptcha

  constructor(
    public navCtrl: NavController,
    public oauthService: OauthService,
    private loginService: LoginService,
    private formBuilder: FormBuilder,
    public lsService: LocalStorageService,
    public toast: ToastDirective,
    public loadingService: LoadingService,
    private contextInitializerService: ContextInitializerService,
    public environnementInitializer: EnvironnementInitializer,
    private environnementProvider: EnvironnementProvider,
    private appProvider: AppProvider,
    private storage: UserStorageService,
    private navParams: NavParams,
    private webSliderService: WebSliderService,
    private menuService: MenuService,
    private alertCtrl: AlertController,
    private config: Config,
    private appRef: ApplicationRef
  ) {
    this.authService = new AuthService(
      this.allowedMode,
      this.navCtrl,
      this.oauthService,
      this.storage
    );
    this.currentMode = this.authService.currentMode;
    this.username = this.navParams.get('email') ? this.navParams.get('email') : null;
    this.connexionLoginTemp = this.navParams.get('loginTemp') ? this.navParams.get('loginTemp') : false;
    this.createForm();
    this._version = (this.environnementProvider.isPreproduction() ? 'pp_' : '') + 'v' + this.appProvider.version;
    (window as any).callBackCaptcha = this.callBackCaptcha.bind(this);
  }

  ngOnInit(): void {
    this.getWebSliderConnexion();
  }

  ionViewDidEnter(): void {
    this.loadingService.end();
    if (this.oauthService.userIsLoggedIn()) {
      this.authService.redirectOut();
    }
    this.initCaptcha();
    // this.environnementInitializer.isSupported();
  }

  ionViewCanEnter(): boolean {
    return true;
  }

  createForm(): void {
    const group = {
      username: [this.username, Validators.required],
      password: ['', Validators.required],
    };
    if (this.environnementInitializer.captcha) {
      group['h-captcha-response'] = ['', Validators.required];
    }
    this.loginForm = this.formBuilder.group(group);
  }

  login(form): void {

    this.submitted = true;  // Active les erreurs après soumission

    if (form.invalid) {
      return;  // Arrête si invalide
    }

    this.menuService.removeSession();
    this.loadingService.start();
    this.loginService
      .login(form.value)
      .then(res => {
        if (res.need_2fa) {
          this.modal2FA = true;
          this.loadingService.end();
        } else {
          this.contextInitializerService
            .initialize()
            .then(() => {
              this.handleLoginSuccess();
            })
            .catch(() => {
              console.log();
            });
        }
        this.resetCaptcha();
      }).catch(() => {
        this.loadingService.end();
        this.resetCaptcha();
    });
  }

  openLostPassword(premiereConnexion = false): void {
    this.navCtrl.push('LostPasswordPage', {premiereConnexion: premiereConnexion});
  }

  handleLoginSuccess(): void {
    const message = this.oauthService.getOauthMessage() ? this.oauthService.getOauthMessage() : 'Connexion réussie';
    this.toast.clearToasts();
    this.isLoggedIn = true;
    this.toast.create(message, 3000, 'success');
    this.authService.redirectOut();
  }

  getWebSliderConnexion(): void {
    if (this.environnementProvider.isSiteWeb()) {
      this.webSliderService.getWebSlidersByUrlSiteWeb(window.location.host).subscribe(resp => {
        if (resp) {
          this.webSliderConnexion = resp;
        }
      });
    }
  }

  closePopin2FA(): void {
    this.otp = [null, null, null, null, null, null];
    this.modal2FA = null;
  }

  valid2FA(): void {
    if (this.otp.indexOf(null) !== -1) {
      this.errorOtp = true;
      return;
    }

    this.loadingService.start();
    this.loading = true;
    this.loginService.code2FA(Number(this.otp.join(''))).then(() => {
          this.closePopin2FA();
      this.contextInitializerService
        .initialize()
        .then(() => {
          this.handleLoginSuccess();
        })
        .catch(() => {
          this.loading = false;
          this.loadingService.end();
          console.log();
        });
        }).catch(error => {
      this.loading = false;
      this.loadingService.end();
      if (error.error && error.error.error === 'invalid_grant') {
        if (this.environnementProvider.isPreproduction()) {
          this.presentAlertPreprod();
        } else {
          this.toast.createAdv({
            message: 'L\'identifiant et le mot de passe ne correspondent pas.',
            type: 'danger'
          });
        }
      } else if (error.error && error.error.message) {
        this.toast.createAdv({
          message: error.error.message,
          type: 'danger'
        });
      } else {
        this.toast.createAdv({
          message: 'Une erreur est survenue',
          type: 'danger'
        });
      }
    });
  }

  presentAlertPreprod(): void {
    const alert = this.alertCtrl.create({
      title: 'Information',
      cssClass: 'help-width',
      message: 'Pocket\'CSE est en cours de finalisation et non encore disponible. Pour l\'instant vous devez continuer d\'utiliser Pocket\'CE. Encore un peu de patience avant de pouvoir utiliser la nouvelle génération de notre Application.',
      buttons: [{
        text: 'Fermer',
        role: 'cancel',
      }],
    });

    alert.present();
  }


  public otpController(event, next, prev, nextIndex): any {
    if (event.target.value.length < 1 && prev) {
      prev.setFocus();
    } else if (next && event.target.value.length > 0) {
      next.setFocus();
      if (nextIndex) {
        this.otp[nextIndex] = null;
      }
    }

    if (this.otp.indexOf(null) !== -1) {
      this.errorOtp = false;
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }


  initCaptcha(): void {
    if (this.environnementInitializer.captcha) {
      setTimeout(() => {
        this.hCaptcha = hcaptcha.render('captcha-1', {
          sitekey: this.environnementProvider.default.hcaptcha_sitekey,
          callback: 'callBackCaptcha'
        });
      }, 100 );
    }
  }

  resetCaptcha(): void {
    if (this.hCaptcha) {
      hcaptcha.reset(this.hCaptcha);
      const captchaControl = this.loginForm.controls['h-captcha-response'];
      if (captchaControl) {
        captchaControl.setValue('');  // Set la valeur du control
        captchaControl.markAsTouched();  // Marque comme touché pour trigger la validation
        captchaControl.updateValueAndValidity();  // Force la mise à jour de la validité
        this.appRef.tick();
      }
    }
  }

  callBackCaptcha(token: string): void {
    this.captchaToken = token;
    const captchaControl = this.loginForm.controls['h-captcha-response'];
    if (captchaControl) {
      captchaControl.setValue(this.captchaToken);  // Set la valeur du control
      captchaControl.markAsTouched();  // Marque comme touché pour trigger la validation
      captchaControl.updateValueAndValidity();  // Force la mise à jour de la validité
      this.appRef.tick();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts